/* =============================================================================
 * Reservation status registry (calendar)
 * -----------------------------------------------------------------------------
 * Canonical mapping for the PMS calendar's reservation statuses. The numeric
 * `value` (0–10) matches the app's existing status enum (see ReservationPage
 * `statusOptions`) so the eventual calendar migration can map a raw status
 * straight to a tile without re-deciding colors. Colors live as CSS custom
 * properties in calendar.css (`--ps-res-{key}-*`) and are applied via the
 * `ps-rtile--{key}` class — the hues intentionally match today's calendar so
 * staff recognition is preserved; only the tile shape/typography modernizes.
 * ========================================================================== */

export const RESERVATION_STATUSES = [
  { value: 0,  key: 'reserved',     label: 'Reserved' },
  { value: 1,  key: 'confirmed',    label: 'Confirmed' },
  { value: 2,  key: 'cancelled',    label: 'Cancelled' },
  { value: 3,  key: 'arrival',      label: 'Arrival due in' },
  { value: 4,  key: 'checked-in',   label: 'Checked in' },
  { value: 5,  key: 'due-out',      label: 'Due out' },
  { value: 6,  key: 'checked-out',  label: 'Checked out' },
  { value: 7,  key: 'no-show',      label: 'No-show' },
  { value: 8,  key: 'stayover',     label: 'Stayover' },
  { value: 9,  key: 'skipped',      label: 'Skipped' },
  { value: 10, key: 'tentative',    label: 'Tentative' },
];

/** Non-reservation calendar overlays (separate data types, own palettes). */
export const CALENDAR_BLOCK_TYPES = [
  { key: 'blocked',        label: 'Blocked' },
  { key: 'courtesy-hold',  label: 'Courtesy hold' },
  { key: 'out-of-service', label: 'Out of service' },
  { key: 'out-of-order',   label: 'Out of order' },
  { key: 'allocation',     label: 'Highlighted allocation' },
];

const VALUE_TO_KEY = RESERVATION_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.key;
  return acc;
}, {});

/** Resolve a calendar status key from the app's numeric status (0–10). */
export const statusKeyFromValue = (value) => VALUE_TO_KEY[value] || 'reserved';
